import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/site-data";
import { Reveal, Eyebrow } from "./Reveal";

export default function Faq() {
  return (
    <section id="sss" className="relative py-24 md:py-32">
      <div className="absolute inset-0 bg-[#122263]/40" />
      <div className="relative mx-auto max-w-4xl px-5 md:px-8">
        <Reveal>
          <Eyebrow>Sıkça Sorulan Sorular</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-syne text-3xl font-bold tracking-tight md:text-5xl">
            Aklınızdaki <span className="text-[#1E7FFF]">Soruların Yanıtları.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <Accordion type="single" collapsible className="mt-12">
            {FAQ.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="mb-3 rounded-xl border border-[#2E4390] bg-[#1A2E78]/70 px-5 backdrop-blur-md transition-colors duration-300 data-[state=open]:border-[#1E7FFF]"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-syne text-base font-bold text-[#F8FAFC] hover:no-underline [&>svg]:text-[#5CA3FF]"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-sm leading-relaxed text-[#B9C4E8]"
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
